/**
 * Telegram 小程序入口。只处理主站。
 * /talkAdventure 等 tel 页仍由页面自己加载 telegram-web-app.js，这里直接跳过。
 */
const TEL_PATHS = ['/groupBag', '/sendBag', '/peopleList', '/compositor', '/talkAdventure', '/wealthRankings', '/telRecharge']
const SCRIPT_SRC = 'https://telegram.org/js/telegram-web-app.js'

export function isTelPath(path) {
  if (!path) return false
  const pure = path.split('?')[0]
  return TEL_PATHS.some(item => pure === item || pure.startsWith(item + '/'))
}

function parseHashQuery(query) {
  const result = {}
  query.split('&').forEach(pair => {
    if (!pair) return
    const index = pair.indexOf('=')
    const key = index >= 0 ? pair.slice(0, index) : pair
    const value = index >= 0 ? pair.slice(index + 1) : ''
    result[decodeURIComponent(key)] = value
  })
  return result
}

function parseLocationHash() {
  const raw = (location.hash || '').replace(/^#/, '')
  if (!raw || raw.indexOf('tgWebApp') === -1) return null
  let route = ''
  let query = raw
  if (raw.charAt(0) === '/') {
    const queryIndex = raw.indexOf('?')
    const ampIndex = raw.indexOf('&')
    let splitAt = -1
    if (queryIndex >= 0) splitAt = queryIndex
    else if (ampIndex >= 0) splitAt = ampIndex
    if (splitAt >= 0) {
      route = raw.slice(0, splitAt)
      query = raw.slice(splitAt + 1)
    } else {
      route = raw
      query = ''
    }
  }
  const params = parseHashQuery(query)
  if (!params.tgWebAppData) return null
  return { route, tgWebAppData: params.tgWebAppData }
}

/**
 * 必须在 new VueRouter 之前调用。
 * Telegram 把 tgWebAppData 放在 hash 上，和当前 hash 路由冲突。
 * 主站先取出 initData，再把 hash 还原成原路由；tel 页保持原 hash。
 */
export function prepareTelegramHash() {
  const parsed = parseLocationHash()
  if (!parsed) return
  let initData = ''
  try {
    initData = decodeURIComponent(parsed.tgWebAppData)
  } catch (e) {
    initData = parsed.tgWebAppData
  }
  const params = new URLSearchParams(initData)
  const startParam = params.get('start_param') || ''
  const hash = params.get('hash') || ''
  const startPath = startParam && startParam.charAt(0) === '/' ? startParam : (startParam ? '/' + startParam : '')
  if (isTelPath(parsed.route) || isTelPath(startPath)) return
  const route = parsed.route || (!isTelPath(startPath) ? startPath : '')
  window.__TG_MINI_APP__ = { initData, startParam, hash, route }
  const nextHash = route ? '#' + route : '#/'
  if (location.hash !== nextHash) {
    history.replaceState(null, '', location.pathname + location.search + nextHash)
  }
}

function loadTelegramScript() {
  if (window.Telegram && window.Telegram.WebApp) return Promise.resolve()
  return new Promise(resolve => {
    const script = document.createElement('script')
    script.src = SCRIPT_SRC
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => resolve()
    document.head.appendChild(script)
  })
}

export async function bootstrapTelegram(store) {
  const payload = window.__TG_MINI_APP__
  if (!payload || !payload.initData) return
  document.documentElement.classList.add('tg-miniapp')
  await loadTelegramScript()
  const webApp = window.Telegram && window.Telegram.WebApp
  if (webApp) {
    webApp.ready()
    webApp.expand()
  }
  if (store.getters.token) return
  const hash = (webApp && webApp.initDataUnsafe && webApp.initDataUnsafe.hash) || payload.hash || ''
  try {
    await store.dispatch('user/loginByTelegram', {
      initData: payload.initData,
      hash
    })
  } catch (e) {
    // 后端未就绪或校验失败时仍按未登录打开主站
  }
}
